<template>
    <div>
        <h2>{{ $t('proposal.header') }}</h2>
        <transition name="slide-fade" v-if="requestedInstallation && !placedInstallation">
            <div class="block has-small-margin-bottom has-no-top-margin order-information">
                <div class="information-header">
                    <h2>{{ $t('form.installation.has_ordered_information.thank_you_time') }}</h2>
                    <h4>{{ $t('form.installation.has_ordered_information.successfully_requested') }}</h4>
                </div>
                <div class="information-body">

                    <div class="body-content">
                        <img src="static/img/icons/calendar.svg" class="content-icon" alt="calendar icon" />
                        <p class="date">{{ useMoment(deliveryDate, 'DD/MM/YYYY', 'dddd, D MMMM YYYY') }}</p>
                    </div>

                    <div class="body-content">
                        <img src="static/img/icons/mail.svg" class="content-icon" alt="mail icon" />
                        <p>{{ $t('form.installation.has_ordered_information.email_mail') }}</p>
                    </div>

                    <div class="body-content">
                        <img src="static/img/icons/location.svg" class="content-icon" alt="location icon" />
                        <p>{{ $t('form.installation.has_ordered_information.location') }}</p>
                    </div>

                    <div class="body-content">
                        <p>{{ $t('form.installation.has_ordered_information.email_calendar') }}</p>
                    </div>
                </div>
                <hr class="border">
                </hr>
                <div class="information-footer">
                    <h4>{{ $t('form.installation.has_ordered_information.phone') }}</h4>
                    <div class="footer-contact">
                        <img src="static/img/icons/phone.svg" class="icon-small" alt="location icon" />
                        <p>0800 / 24 550</p>
                    </div>
                </div>
            </div>
        </transition>
        <loader :loading="fetchingAvailableContactMoments" :error="errorFetchingAvailableContactMoments">
            <div class="row">
                <div v-if="!fetchingAvailableContactMoments && availableContactMoments && !requestedInstallation && !placedInstallation"
                    class="col-12 col-md-12 col-l-12 col-xl-10">
                    <div class="block has-small-margin-bottom has-no-top-margin has-small-padding-top">
                        <p>{{ $t('form.installation.label_info') }}</p>
                        <p v-if="availableContactMoments && availableContactMoments.length === 0">
                            {{ $t('form.order_salt.no_available_dates_found') }}</p>
                        <div class="row justify-content-center order-container">
                            <div v-for="option in availableContactMoments" @click="selectOption(option)"
                                :key="option.date" class="container-option"
                                :class="selectedOption === option ? 'selected' : ''">
                                <p class="day-name">{{ useMoment(option.date, 'YYYY-MM-DD', 'dddd') }}</p>
                                <h2 class="day-date">{{ useMoment(option.date, 'YYYY-MM-DD', 'D MMM').replace('.', '')
                                }}
                                </h2>
                            </div>
                        </div>
                    </div>
                    <div class="row gap-y-1">
                        <div class="col-xl-6">
                            <div class="block has-no-top-margin has-small-margin-bottom has-small-padding-top">
                                <div class="address-header">
                                    <h4>{{ $t('form.installation.appointment.address') }}</h4>
                                </div>
                                <div class="address-group">
                                    <p v-for="(value) in address">
                                        {{ value ? value : '-' }}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-6">
                            <div class="block has-no-top-margin has-small-margin-bottom has-small-padding-top">
                                <h4>{{ $t('form.appointment.label_comment') }}</h4>
                                <textarea class="block__textarea form__input--textarea border_dark" v-model="comment"
                                    :placeholder="$t('form.appointment.placeholder_comment')"></textarea>
                            </div>
                        </div>
                    </div>
                    <div class="container-fluid no-padding">
                        <div class="flex justify-content-end ">

                            <button class="button--cta no-margin-x" :disabled="disabled" @click="onSubmit">{{
                                $t('form.installation.button_submit') }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </loader>
    </div>
</template>
<script>
import Vue from 'vue';
import {
    SUBMIT_ORDER,
    GET_SCHEDULING_INSTALLATION,
    SET_SCHEDULING_INSTALLATION
} from '../store/modules/plan_installation';
import {
    GET_INSTALLATION_PROGRESS,
    GET_INSTALLATION_PLACED,
    FETCH_INSTALLATION_PROGRESS
} from '../store/modules/proposal_progress';
import { GET_FIELD } from '../store/modules/account_details';
import { Component, Watch } from 'vue-property-decorator';
import {
    FETCH_AVAILABLE_CONTACT_MOMENTS,
    GET_AVAILABLE_CONTACT_MOMENTS,
    GET_FETCHING_AVAILABLE_CONTACT_MOMENTS,
    GET_ERROR_FETCHING_AVAILABLE_CONTACT_MOMENTS,
    SET_ERROR_FETCHING_AVAILABLE_CONTACT_MOMENTS,
    GET_SELECTED_OPTION,
    SET_SELECTED_OPTION,
    GET_COMMENT,
    SET_COMMENT
} from '../store/modules/available_contact_moments';
import Loader from '../components/general/Loader.vue';
import moment from 'moment';
import Raven from 'raven-js';

@Component({
    components: { Loader }
})
export default class WelcomePage extends Vue {
    address = {
        full_name: '',
        street: '',
        number: '',
        postalCode: '',
        city: '',
        country: ''
    }

    created() {
        this.fetchAvailableOptions();
        this.setAddress();
    }

    @Watch('accountFields', { deep: true })
    onAccountFieldsChange() {
        this.setAddress();
    }

    get accountFields() {
        return this.$store.state.account_details.fields;
    }

    get installationProgress() {
        return this.$store.getters[GET_INSTALLATION_PROGRESS];
    }

    get requestedInstallation() {
        return this.installationProgress.requested.completed;
    }

    get placedInstallation() {
        return this.$store.getters[GET_INSTALLATION_PLACED];
    }

    get deliveryDate() {
        if (this.installationProgress.install.date) {
            return this.installationProgress.install.date;
        } else {
            return this.installationProgress.requested.date;
        }
    }

    get fetchingAvailableContactMoments() {
        return this.$store.getters[GET_FETCHING_AVAILABLE_CONTACT_MOMENTS];
    }

    get errorFetchingAvailableContactMoments() {
        return this.$store.getters[GET_ERROR_FETCHING_AVAILABLE_CONTACT_MOMENTS];
    }

    get selectedOption() {
        return this.$store.getters[GET_SELECTED_OPTION];
    }

    get comment() {
        return this.$store.getters[GET_COMMENT];
    }
    set comment(value) {
        this.$store.commit(SET_COMMENT, value);
    }

    get schedulingInstallation() {
        return this.$store.getters[GET_SCHEDULING_INSTALLATION];
    }

    async fetchAvailableOptions() {
        try {
            await this.$store.dispatch(FETCH_AVAILABLE_CONTACT_MOMENTS, { type: 'installation' });
        } catch (e) {
            this.$store.commit(SET_ERROR_FETCHING_AVAILABLE_CONTACT_MOMENTS, this.$t('form.order_salt.error_fetching_available_contact_moments'));
        }
    }

    async onSubmit() {
        if (!this.disabled) {
            this.$store.commit(SET_SCHEDULING_INSTALLATION, true);
            try {
                let payload = {
                    date: this.selectedOption.date,
                    comment: this.comment,
                    driver_id: this.selectedOption.driver_id
                };
                await this.$store.dispatch(SUBMIT_ORDER, payload);
                this.$notify.success(this.$t('form.installation.notify_success'));
            } catch (e) {
                if (e.response && e.response.data && e.response.data.message) {
                    this.$notify.error(e.response.data.message);
                    await this.fetchAvailableOptions();
                } else {
                    this.$notify.error(this.$t('form.installation.notify_failure'));
                }
                Raven.captureException(e);
            } finally {
                this.$store.commit(SET_SCHEDULING_INSTALLATION, false);
            }
            await this.$store.dispatch(FETCH_INSTALLATION_PROGRESS);
        }
    }

    async setAddress() {
        const addressValue = this.getFieldValue('address');
        if (!addressValue || addressValue === 'address') {
            // Data not ready yet, watcher will call this method again when it's available
            return;
        }
        this.address.full_name = this.getFieldValue('name');
        this.address.street = addressValue;
        this.address.number = this.getFieldValue('address_number');
        this.address.postalCode = this.getFieldValue('postal_code');
        this.address.city = this.getFieldValue('city_name');
        this.address.country = this.getFieldValue('country_name');
    }

    selectOption(option) {
        this.$store.commit(SET_SELECTED_OPTION, option);
    }

    getFieldValue(field) {
        return this.$store.getters[GET_FIELD](field);
    }

    get availableContactMoments() {
        return this.$store.getters[GET_AVAILABLE_CONTACT_MOMENTS];
    }

    get disabled() {
        return this.schedulingInstallation || !this.selectedOption;
    }

    getDateLabel() {
        const date = this.lastOrder.action_timestamp;
        if (date) {
            return moment(date, 'DD-MM-YYYY hh:mm:ss').format('ddd ll') ?
                moment(date, 'DD-MM-YYYY hh:mm:ss').format('ddd ll')
                :
                date;
        }
    }

    useMoment(date, format, output) {
        return moment(date, format).format(output);
    }

    get contactUrl() {
        return this.$t('account_info.address_information_contact_url');
    }

}
</script>



// WEBPACK FOOTER //
// src/pages/WelcomePage.vue